<template>
  <div
    class="Fuell-Table"
    v-if="!isLoading"
  >
    <div class="Fuell-Table--header Fuell-Table--row Fuell-Table--row-exportsHistory">
      <div class="Fuell-Table--item">
        <span>{{ $t('export_flow_exported_date') }}</span>
      </div>
      <div class="Fuell-Table--item">
        <span>{{ $t('export_flow_exported_exportation') }}</span>
      </div>
      <div class="Fuell-Table--item">
        <span>{{ $t('export_flow_exported_file') }}</span>
      </div>
      <div class="Fuell-Table--item">
        <span>{{ $t('export_flow_exported_filters') }}</span>
      </div>
      <div class="Fuell-Table--item">
        <span>{{ $t('export_flow_exported_format') }}</span>
      </div>
      <div class="Fuell-Table--item">
        <span>{{ $t('export_flow_exported_status') }}</span>
      </div>
      <div class="Fuell-Table--item"><span></span></div>
    </div>
    <exported-table-row
      v-for="exportHistory in exportsHistory"
      :exportHistory="exportHistory"
      :key="exportHistory.id"
    ></exported-table-row>
  </div>
  <div
    class="w-100 h-100 d-flex justify-content-center align-items-center"
    v-else
  >
    <spinner></spinner>
  </div>
</template>

<script>
import Spinner from '@/components/Commons/Spinner'
import ExportedTableRow from './ExportedTableRow'
import _paginationHandlerMixin from '@/components/Commons/_mixins/_paginationHandlerMixin'

export default {
  name: 'ExportedTable',
  components: { ExportedTableRow, Spinner },
  mixins: [_paginationHandlerMixin],
  data () {
    return {
      isLoading: false
    }
  },

  computed: {
    exportationFlow () {
      return this.$store.getters['ExportStore/exportationFlows'].length > 0 ? this.$store.getters['ExportStore/exportationFlow'] : {}
    },
    exportsHistory () {
      return this.$store.getters['ExportStore/exportsHistory']
    },
    currentPage () {
      return this.$store.getters['ExportStore/exportedCurrentPage']
    },
    lastPage () {
      return this.$store.getters['ExportStore/exportedLastPage']
    }
  },
  methods: {
    nextPage () {
      this.$store.dispatch('ExportStore/nextFileFormatsPage')
    },
    async fetchExported () {
      let filters = {
        'order[createdAt]': 'DESC'
      }
      this.$store.dispatch('ExportStore/setExportsHistoryFilters', filters)
      await this.$store.dispatch('ExportStore/fetchExportsHistory', { pagination: true })
    }
  },
  async created () {
    this.isLoading = true
    await this.fetchExported()
    this.isLoading = false
  }
}
</script>

<style scoped>
.Fuell-Table {
  padding-bottom: 100px;
}
</style>
